import { createSlice, SliceCaseReducers } from '@reduxjs/toolkit';
import { deleteFileAction } from 'store/actions/file';
import { FetchStatus } from 'types/api';
import { IFile } from 'types/file';

export interface IFileset {
    id: number;
    conference?: number;
    lesson: number;
    files: (IFile & { isTemplate?: boolean; fileName: string })[];
}

export interface FileState {
    fetchStatusDelete: FetchStatus;
    fileset: IFileset;
    error: unknown;
}

const initialState: FileState = {
    fileset: {
        id: -1,
        lesson: -1,
        files: [],
    },
    fetchStatusDelete: FetchStatus.INITIAL,
    error: null,
};

const fileSlice = createSlice<FileState, SliceCaseReducers<FileState>>({
    name: 'file',
    initialState,
    reducers: {
        // standard reducer logic, with auto-generated action types per reducer
    },
    extraReducers: (builder) => {
        builder
            .addCase(deleteFileAction.pending, (state) => {
                state.fetchStatusDelete = FetchStatus.FETCHING;
                state.error = null;
            })
            .addCase(deleteFileAction.fulfilled, (state, { payload }) => {
                state.fetchStatusDelete = FetchStatus.FETCHED;
                if (state.fileset?.files) {
                    state.fileset.files = state.fileset?.files.filter(({ id }) => id !== payload.id);
                }
            })
            .addCase(deleteFileAction.rejected, (state, { error }) => {
                state.fetchStatusDelete = FetchStatus.ERROR;
                state.error = error;
            });
    },
});

export const fileReducer = fileSlice.reducer;
